



























import { Component, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import DialogDetail from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box1/dialogDetail.vue';

@Component({
  components: { DialogDetail },
})
export default class Dialog1 extends Vue {
  private dialogVisible = false;
  private title = '';

  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total: any = 0;
  private tableData: any = [];

  private filterForm: any = {
    areaId: '',
    level: [],
  };

  mounted() {}

  private showDialog(data: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.title = data.levelTitle;
    this.filterForm.areaId = data.areaId;
    this.filterForm.level = data.level;
    this.getData();
    this.dialogVisible = true;
  }
  private getData() {
    zyScreenServer
      .getBYRiskLevelData({
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        ...this.filterForm,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning(res.msg);
        }
      });
  }
  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getData();
  }
  showDetail(item: any) {
    const refName = 'DialogDetailRef';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(item);
  }

  handleClose(done: any) {
    done();
  }
}
